"use client";

import { Button as AntButton, type ButtonProps as AntButtonProps } from "antd";
import clsx from "clsx";

interface ButtonProps extends AntButtonProps {
    type?: "primary" | "default" | "text";
    href?: string;
    onClick?: () => void;
    className?: string;
    size?: "small" | "middle" | "large";
    children?: React.ReactNode;
}

const XButton: React.FC<ButtonProps> = ({
    type = "default",
    href,
    onClick,
    className,
    size = "large",
    children,
    disabled,
    loading,
    ...rest
}) => {
    const baseClasses = "px-6 !py-2 transition-all duration-200";

    const buttonClass = clsx(
        baseClasses,
        {
            // Default button
            "hover:!bg-[#D87C45] !text-[#D87C45] hover:!text-white !border-[#D87C45] ":
                type === "default",

            // Primary button
            "!bg-[#D87C45] hover:!bg-[#c66f3e] !text-white border-none":
                type === "primary",

            // Text button (icon or minimal buttons)
            "!border-none !shadow-none p-1 !text-gray-600 hover:!text-[#D87C45] ": //temporary remove this    
                type === "text",

            // Disabled styles
            "!bg-[#D87C45] opacity-70 !text-white !border-[#D87C45] !cursor-default hover:!bg-[#D87C45] dark:!bg-[#D87C45] dark:!text-white dark:!border-[#D87C45]":
                disabled && !loading,

            "cursor-progress": loading,
        },
        className
    );

    return (
        <AntButton
            type={type === "primary" ? "primary" : type === "text" ? "text" : "default"}
            size={size}
            href={href}
            onClick={onClick}
            className={buttonClass}
            disabled={disabled}
            loading={loading}
            {...rest}
        >
            {children}
        </AntButton>
    );
};

export default XButton;